import React from "react";
import classNames from "classnames";
import { ChipProps } from "./types";
import "./styles.scss";

export function Chip({
  id,
  label,
  type,
  color,
  className,
  size,
  width,
  mobile,
  tablet,
  style,
  icon,
}: ChipProps) {
  const classnames = classNames(`Chip`, {
    [`Chip--${type}`]: type,
    "Chip--primary": color === "primary",
    "Chip--secondary": color === "secondary",
    "Chip--success": color === "success",
    "Chip--warning": color === "warning",
    "Chip--danger": color === "danger",
    "Chip--inactive": color === "inactive",
    "Chip--neutral": color === "neutral",
    "Chip--black": color === "black",
    "Chip--medium": size === "medium",
    "Chip--fit-content": width === "fit-content",
    "Chip--tablet": tablet === true,
    "Chip--mobile": mobile === true,
    [className]: className,
  });

  const renderChipWithIcon = () => {
    if (icon) {
      return (
        <div className="text">
          {icon.position === "left" && icon.component && (
            <div className="text__icon text__icon--left">{icon.component}</div>
          )}
          <span className="text">{label}</span>
          {icon.position === "right" && icon.component && (
            <div className="text__icon text__icon--right">{icon.component}</div>
          )}
        </div>
      );
    } else {
      return <span className="text">{label}</span>;
    }
  };

  return (
    <div
      className={classnames}
      data-testid="Chip"
      style={style}
      id={id}
    >
      {renderChipWithIcon()}
    </div>
  );
}
